const faqs = [
  {
    question: "Does Maine have its own regional passport agency?",
    answer:
      "No, Maine does not have a regional passport agency within the state. The nearest regional passport agency for most Maine residents is the Boston Passport Agency in Massachusetts (approximately 2–3 hours from Portland). For those in northern or eastern Maine, travel to Boston can take 5+ hours. Using an approved courier service like Fast Passport Center eliminates the need to drive to Massachusetts.",
  },
  {
    question: "How fast can I get a passport in Maine?",
    answer:
      "With Fast Passport Center's courier service, Maine travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks. Because Maine lacks a regional agency, courier service is often the fastest option for urgent needs.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Maine?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, town clerk, or library). Many small-town Maine post offices offer this service by appointment. Renewals for adults can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which Maine airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Maine's primary international departure points are Portland International Jetport (PWM) and Bangor International (BGR). Both offer seasonal direct flights to Canada and connecting service to Europe and beyond.",
  },
  {
    question: "Can I renew by mail from Maine?",
    answer:
      "Yes. If your most recent passport was issued when you were 16 or older, was issued within the last 15 years, and is undamaged, you can renew by mail using Form DS-82. Mail your application to the address on the form — no need to visit an acceptance facility. For faster turnaround, use our expedited courier service.",
  },
  {
    question: "Where is the best place to get a passport photo in Maine?",
    answer:
      "CVS, Walgreens, UPS Store, and FedEx Office locations in Portland, South Portland, Bangor, and Augusta all offer passport photo services. Many small-town pharmacies can also take compliant photos. Always verify the photo meets the 2×2 inch, white-background requirement before submitting.",
  },
];

export { faqs };

export default function MaineFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Maine Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Maine.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}